export default __webpack_public_path__ + "static/media/postease-header-text.b9a8931b.svg";